export default __webpack_public_path__ + "existing-staff-blue-icon.svg";